import { useRef, useEffect } from 'react';
import TextScramble from '../utils/textScramble';

/**
 * Custom hook for text scramble effect
 * @param {string} text - The original text to display
 * @returns {Object} - The ref to attach to the element
 */
const useTextScramble = (text) => {
  const elementRef = useRef(null);
  const scramblerRef = useRef(null);
  
  useEffect(() => {
    // Initialize the scrambler
    if (!scramblerRef.current) {
      scramblerRef.current = new TextScramble();
    }
  }, []);

  useEffect(() => {
    const element = elementRef.current;
    if (!element || !text) return;
    
    // Set the initial text
    if (element.innerText !== text) {
      element.innerText = text;
    }
  }, [text]);

  const handleMouseEnter = () => {
    const element = elementRef.current;
    if (!element || !scramblerRef.current) return;
    
    // Store the original text
    const originalText = element.innerText;
    
    // Set the element on the scrambler instance
    scramblerRef.current.el = element;
    
    // Start the scramble effect with a very short duration (200ms)
    // The text will revert to original after this duration
    scramblerRef.current.setText(element, originalText, 200);
  };
  
  // Add a method to reset the text to original
  const resetText = () => {
    const element = elementRef.current;
    if (!element || !text) return;
    
    // Reset to the original text
    element.innerText = text;
  };

  return { ref: elementRef, onMouseEnter: handleMouseEnter, resetText };
};

export default useTextScramble;